import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconHeartVoid: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.6398 4.5C18.6398 2.5 15.3398 2.5 13.3398 4.5L12.0398 5.7L10.7398 4.5C8.73977 2.5 5.43977 2.5 3.43977 4.5C1.33977 6.5 1.73977 9.9 3.33977 12C5.33977 14.6 11.0398 20.5 11.3398 20.8C11.5398 20.9 11.7398 21 12.0398 21C12.3398 21 12.5398 20.9 12.7398 20.7C12.9398 20.5 18.7398 14.6 20.7398 11.9C22.2398 9.9 22.6398 6.5 20.6398 4.5ZM19.1398 10.7C17.6398 12.7 13.6398 16.8 12.0398 18.5C10.4398 16.8 6.43977 12.7 4.93977 10.7C3.93977 9.3 3.53977 7.1 4.83977 5.9C5.43977 5.3 6.33977 5 7.13977 5C7.93977 5 8.73977 5.3 9.43977 5.9L11.4398 7.8C11.8398 8.2 12.4398 8.2 12.8398 7.8L14.8398 5.9C16.0398 4.7 18.1398 4.7 19.3398 5.9C20.4398 7.1 20.1398 9.4 19.1398 10.7Z',
    })
  )
}
